import * as yup from 'yup';

const wabSettingsSchema = yup.object({
  value: yup.number().required().min(100).max(200),
  groupId: yup.number().required(),
  settingId: yup.number(),
  key: yup.string().required()
});

const hourManagementSettingsSchema = yup.array().of(
  yup.object({
    value: yup.string().required(),
    groupId: yup.number().required(),
    settingId: yup.number(),
    key: yup.string().required()
  })
);

const booleanSchema = yup.object({
  value: yup.boolean().required(),
  groupId: yup.number().required(),
  settingId: yup.number(),
  key: yup.string().required()
});

export const hourManagementSchema = yup.object({
  warningPercentage: wabSettingsSchema,
  alertPercentage: wabSettingsSchema,
  hourManagementSettingsSchema,
  yearClosureSettingsSchema: booleanSchema,
  balanceBudgetAllYears: booleanSchema,
  balanceBudgetPlb: booleanSchema
});
